<template>
  <svg
    width="16"
    height="9"
    viewBox="0 0 16 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5241 8.15948L7.93287 1.56823L1.0007 7.36398"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
